// Import Constants
import { l } from 'constants/common';

const data = [
    { label: l.Yes, value: true },
    { label: l.No, value: false },
];

export { data };
